import { styled } from '@moonpig/launchpad-utils'

export const StyledSectionTitle = styled.div`
  background: #eeeff1;
  width: 100%;
  padding: 2px 2px 2px 10px;
  margin: 2px 0px 2px 0px;
`
